<div class="dialog__wrapper">
  <div class="dialog__header" mat-dialog-title>
    <h4 class="dialog__title">Notes</h4>
    <button mat-icon-button mat-dialog-close>
      <mat-icon fontIcon="close"></mat-icon>
    </button>
  </div>
  <mat-dialog-content class="dialog__content">
    <mat-radio-group [(ngModel)]="filterMode" [disabled]="notes.length === 0" *ngIf="showAttachements">
      <mat-radio-button value="all">All</mat-radio-button>
      <mat-radio-button value="attachments-only">Attachments Only</mat-radio-button>
    </mat-radio-group>
    <div>
      @if (notes.length > 0) {
        @for (note of filteredNotes; track $index) {
          <section class="dialog__note-container">
            <div
              [class]="{
                'dialog__note-header': true,
                'dialog__system-note': note.noteType === NoteType.System,
                'dialog__manual-note': note.noteType === NoteType.UserCreated,
              }"
            >
              <span class="dialog__author">{{ note.creator }}</span>
              <span class="dialog__date">{{ note.createDate | date: 'M/d/yy, h:mm a' }}</span>
            </div>
            <div class="dialog__note-content">
              <div>
                {{ note.noteText }}
              </div>
              @if (note.attachment) {
                <div class="dialog__attachment">
                  <div (click)="handleDownloadAttachment(note.attachment)">
                    <mat-icon>draft</mat-icon>
                    <a>Download File</a>
                  </div>
                </div>
              }
            </div>
          </section>
        }
      } @else {
        <section class="dialog__no-notes">No notes have been added yet.</section>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions cdkFocusRegionstart class="dialog__actions-section">
    <section class="dialog__textarea-section">
      <textarea matInput placeholder="Write a new note" [(ngModel)]="newNoteText" rows="5"></textarea>
      <span [class]="{ 'dialog__characters-remaining': true, 'dialog__over-the-limit': newNoteText.length > allowedLength }"
        >Characters Remaining: [{{ allowedLength - newNoteText.length }}]</span
      >
      <p>{{ allowedFileTypesText }}</p>
    </section>
    <section class="dialog__buttons-section">
      <div class="dialog__file-upload">
        <input type="file" #fileUploadInput (change)="handleFileChange($event.target.files)" style="display: none" />
        <div>
          <button mat-raised-button class="button--secondary" (click)="fileUploadInput.click()" *ngIf="showAttachements">Choose File</button>
        </div>
        <div class="dialog__file-name">{{ file?.name }}</div>
        @if (fileError) {
          <mat-error>{{ fileError }}</mat-error>
        }
      </div>
      <button mat-raised-button [disabled]="submitDisabled" (click)="handleAddNote()">Add</button>
    </section>
  </mat-dialog-actions>
</div>
